<template>
  <div class="footer-wrapper">
    <div class="list-wrap">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="title">买家服务</div>
          <div class="li">供应商入驻</div>
          <div class="li">电商分销</div>
          <div class="li">API采购</div>
        </el-col>
        <el-col :span="4">
          <div class="title">卖家服务</div>
          <div class="li">卡券回收</div>
          <div class="li">API供应</div>
        </el-col>
        <el-col :span="4">
          <div class="title">文档中心</div>
          <div class="li">业务教程</div>
          <div class="li">常见问题</div>

        </el-col>
        <el-col :span="4">
          <div class="title">关于我们</div>
          <div class="li">企业文化</div>
          <div class="li">意见反馈</div>
        </el-col>
        <el-col :span="4">
          <div class="title">联系我们</div>
          <div class="li">电话：4000000981</div>
          <div class="li">邮箱：cyx@birdicloud.com</div>
        </el-col>
        <el-col :span="4" class="col-right">
          <div class="title code">
            <img src="../assets/qrCode.jpg" alt="">
            <div class="name">皆淘淘公众号</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="filing-wrap">
      <div>Copyright © 神鸟云（北京）科技有限公司 ｜ <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备2025135773号-1</a> ｜ <a href="javascript:void(0)" @click="lookLicense">营业执照</a> ｜ <a href="javascript:void(0)" @click="privacy">隐私政策</a></div>
    </div>
  </div>
</template>

<script>
export default {

  data () {
    return {
    }
  },
  methods: {
    lookLicense() {
      window.open('https://example.com/path/to/your/image.jpg', '_blank')
    },
    privacy() {
      window.scrollTo(0, 0);
      this.$router.push('/privacy')

    }
  }
}
</script>
<style scoped lang="less">
  .footer-wrapper {
    width: 100%;
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    box-sizing: border-box;
    .list-wrap {
      width: 100%;
      padding: 0 17%;
      box-sizing: border-box;
      display: flex;
      /deep/ .el-row {
        width: 100%;
        .col-right {
          border-left: 1px solid #c0c0c0;
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          img {
            width: 140px;
            
          }
        }
        .code {
          text-align: center;
          .name {
            margin-top: 10px;
          }
        }
        .li {
          font-size: 14px;
          margin-top: 10px;
          color: #666666;
        }
      }
    }
    .filing-wrap {
      margin-top: 40px;
      color: #999999;
      font-size: 14px;
      a {
        text-decoration: none;
        color: inherit;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue